export default class Site{
    constructor() {
        /**
         *
         * @type {Site}
         */
        let me = this;
        me._initListeners();
        //---------------------go------------------------------------------
        me.resizeStage();
        me.onDomChange();
        Site.navActive();
    }

    /**
     *
     * @private
     */
    _initListeners() {

        let me=this;

        require("./layout/NavMenu");
        NavMenu.__init();
        require("./components/data-zoom-img");
        require("./components/data-is-lang");
        require("./layout/data-page-transition");
        require("./components/data-scroll-target");




        //require("./blocks/FormContact");
        //FormContact.initFromDom();

        //ferme le menu quand on change d'url
        $body.on(EVENTS.HISTORY_CHANGE_URL,function(){
            $body.attr("data-page-transition-state","start");
            //stope en attendant que la transition soit finie
            PovHistory.readyToinject=false;
            //dit qu'on est prêt à afficher la page (s'assure qu'on reste au moins une seconde sur l'écran de transition)
            setTimeout(function(){
                PovHistory.readyToinject=true;
            },500);
            NavMenu.close();
        });


        //changement d'url et HTML injecté
        $body.on(EVENTS.HISTORY_CHANGE_URL_LOADED_INJECTED,function(){
            $body.attr("data-page-transition-state","end");

            setTimeout(function(){
                $body.attr("data-page-transition-state","");
                $body.attr("data-page-transition","");
            },500);
            me.onDomChange();
            //scroll top
            $(window).scrollTop(0);
            Site.navActive();
            testNavTransparent();
            if(typeof gtag !== 'undefined' && LayoutVars.googleAnalyticsId){
                //hit google analytics
                gtag('config', LayoutVars.googleAnalyticsId, {'page_path': location.pathname});
            }

        });

        function testNavTransparent(){
            if(window.scrollY<=0 && PovHistory.currentPageInfo.isHome){
                NavMenu.$nav.addClass("transparent");
            }else{
                NavMenu.$nav.removeClass("transparent");
            }
        }

        $(window).on('resize scroll', function() {
            let newScroll=window.scrollY;
            $body.trigger("scroll-event");

        });

        $body.on("scroll-event",function(){
            testNavTransparent();
        });

        STAGE.on(EVENTS.RESIZE,function(){
            me.resizeStage();
        });
        $body.on(Pov.events.DOM_CHANGE,function(){
            me.onDomChange();
        });

        testNavTransparent();

    }

    /**
     * Selectionne / déselectionne l'item de nav de la page en cours
     */
    static navActive(){
        $("[data-href-uid]").removeClass("active");
        $("[data-href-uid='"+PovHistory.currentPageInfo.uid+"']").addClass("active");
    }

    /**
     * Adapte des élements à l'écran
     */
    resizeStage(){
        //ou pas :)
    }

    /**
     * Initialisations d'objets dom
     */
    onDomChange(){
        //initialisation de slick
        $('.js-slick').not(".init-done").slick({
            //setting-name: setting-value
            autoplay:true,
            autoplaySpeed:5000,
            arrows:false,
            dots:true,
            pauseOnHover:false,
            pauseOnDotsHover:true,
            fade:true,
            speed:1000
        });
        $('.js-slick').addClass("init-done");

        if(!LayoutVars.wysiwyg){
            $(".block-carousel .carousel").not(".slick-initialized").each(function(){
                $(this).slick(
                    {
                        infinite: true,
                        dots:true,
                        slidesToShow: 1,
                        adaptiveHeight: true,
                        autoplay:true,
                        arrows:true
                    }
                )
            });
        }
    }
}


// WEBPACK FOOTER //
// ./project/_src/Site.js